<template>
  <div class="m-edition-section-navigation-menu">
    <AtomEditionSectionNavigationMenu
      :itemsAsideMenu="itemsAsideMenu"
    />
  </div>
</template>

<script>
import configApp from '@/config'
import mEditionMenu from '@/plugins/languages/es/molecules/m-edition-section-navigation-menu'

// Las secciones que viven detras de droopInteligenciaArtificialHabilitado
const SECCIONES_IA = ['artificialIntelligence', 'artificialIntelligenceUsage', 'artificialIntelligenceCosts']

export default {
  name: 'MoleculeEditionSectionNavigationMenu',

  data () {
    return {
      appVentaItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'fas fa-box-open',
          section: 'products',
          text: `${mEditionMenu.mEditionMenu.billing.products.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.products.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-satellite',
          section: 'satellites',
          text: `${mEditionMenu.mEditionMenu.billing.satellites.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.satellites.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-brain',
          section: 'artificialIntelligence',
          text: `${mEditionMenu.mEditionMenu.billing.artificialIntelligence.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.artificialIntelligence.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-chart-pie',
          section: 'artificialIntelligenceUsage',
          text: `${mEditionMenu.mEditionMenu.billing.artificialIntelligenceUsage.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.artificialIntelligenceUsage.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-balance-scale',
          section: 'artificialIntelligenceCosts',
          text: `${mEditionMenu.mEditionMenu.billing.artificialIntelligenceCosts.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.artificialIntelligenceCosts.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-box-open',
          section: 'academyProducts',
          text: `${mEditionMenu.mEditionMenu.billing.academyProducts.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyProducts.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-folder-open',
          section: 'academyProyects',
          text: `${mEditionMenu.mEditionMenu.billing.academyProyects.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyProyects.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-money-bill-wave',
          section: 'academyCharges',
          text: `${mEditionMenu.mEditionMenu.billing.academyCharges.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyCharges.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-file-invoice-dollar',
          section: 'academySales',
          text: `${mEditionMenu.mEditionMenu.billing.academySales.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academySales.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-user-tie',
          section: 'academyClients',
          text: `${mEditionMenu.mEditionMenu.billing.academyClients.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyClients.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-school',
          section: 'academies',
          text: `${mEditionMenu.mEditionMenu.billing.academies.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academies.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-exchange-alt',
          section: 'academyMigration',
          text: `${mEditionMenu.mEditionMenu.billing.academyMigration.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyMigration.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-users',
          section: 'academyUsers',
          text: `${mEditionMenu.mEditionMenu.billing.academyUsers.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyUsers.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-coins',
          section: 'academyBilling',
          text: `${mEditionMenu.mEditionMenu.billing.academyBilling.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.academyBilling.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-chart-line',
          section: 'studentTracking',
          text: `${mEditionMenu.mEditionMenu.billing.studentTracking.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.studentTracking.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-address-card',
          section: 'usersMonitoring',
          text: `${mEditionMenu.mEditionMenu.billing.usersMonitoring.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.usersMonitoring.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-unlock-alt',
          section: 'modifyPassword',
          text: `${mEditionMenu.mEditionMenu.billing.modifyPassword.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.modifyPassword.subject}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-user',
          section: 'modifyUser',
          text: `${mEditionMenu.mEditionMenu.billing.modifyUser.text}`,
          to: `/gestion/${mEditionMenu.mEditionMenu.billing.modifyUser.subject}`
        }
      ]
    }
  },

  computed: {
    // Inteligencia Artificial sale apagada (configApp.droopInteligenciaArtificialHabilitado): se chequea
    // con === true, asi un entorno que todavia no tiene la clave en src/config/index.js la deja oculta.
    // El flag tapa las DOS pantallas de IA: el catalogo de planes y el monitoreo de lo vendido
    itemsAsideMenu () {
      return this.appVentaItemsAsideMenu.filter(item =>
        !SECCIONES_IA.includes(item.section) || configApp.droopInteligenciaArtificialHabilitado === true
      )
    }
  },

  watch: {
    $route (to, from) {
      this.setItemAsideClasses()
    }
  },

  created () {
    this.setItemAsideClasses()
  },

  methods: {
    setItemAsideClasses () {
      this.itemsAsideMenu.forEach(itemAside => {
        itemAside.class = mEditionMenu.mEditionMenu.billing[`${itemAside.section}`].subject === `${this.$route.params.subject}`
          ? `m-item-aside-active m-item-aside-billing-active`
          : `m-item-aside-billing`
      })
    }
  }
}
</script>
